import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {EmailDTO} from '../models/email/EmailDTO';
import {environment} from '../../../../environments/environment';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private url = environment.baseUrl + '/email';

  constructor(private httpClient: HttpClient) {
  }

  getListOfEmails(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<EmailDTO>> {
    return this.httpClient.post<PagedResponseDTO<EmailDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  sendEmail(emailDTO: EmailDTO): Observable<EmailDTO> {
    return this.httpClient.post<EmailDTO>(this.url + '/smtp', emailDTO);
  }

  resetEmail(emailId: number): Observable<void> {
    return this.httpClient.get<void>(`${this.url}/resetByEmailId?emailId=${emailId}`);
  }


}
